import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { fetchUsers } from '../../store/slices/usersSlice';
import UserStatsCard from '../../common/components/UserStatsCard';
import DataTable from '../../common/components/DataTable';
import { SimplePaginationInfo } from '../../types';
import SuccessIcon from '../../common/assets/icons/success.svg';
import ErrorIcon from '../../common/assets/icons/error.svg';

const UsersGrid: React.FC = () => {
  const dispatch = useAppDispatch();
  const { list, loading, stats } = useAppSelector((state) => state.users);
  const [currentPage, setCurrentPage] = useState(1);
  // Stats are sourced from Redux slice

  useEffect(() => {
    dispatch(fetchUsers());
    // Fetch user statistics
    // usersService.getUserStats().then(setUserStats);
  }, [dispatch]);

  // React to users list changes if needed
  useEffect(() => {
  }, [list]);

  const columns = [
    {
      key: 'sNo',
      label: 'S.No.',
      sortable: true,
      width: 50,
      render: (_value: any, _row: any, rowIndex?: number, pagination?: any) => {
        const start = ((pagination?.page || 1) - 1) * (pagination?.limit || 0);
        return String((start + (rowIndex ?? 0) + 1)).padStart(2, '0');
      }
    },
    {
      key: 'firstname',
      label: 'First Name',
      sortable: true,
      width: 90,
    },
    {
      key: 'lastname',
      label: 'Last Name',
      sortable: true,
      width: 90,
    },
    {
      key: 'userid',
      label: 'User ID',
      sortable: true,
      width: 80,
    },
    {
      key: 'mobilenumber',
      label: 'Mobile Number',
      sortable: true,
      width: 120,
    },
    {
      key: 'email',
      label: 'Email',
      sortable: true,
      width: 150,
    },
    {
      key: 'createddt',
      label: 'Reg. Date',
      sortable: true,
      width: 160,
      render: (value: string) => {
        if (!value) return '-';
        try {
          const date = new Date(value);
          const formattedDate = date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: '2-digit'
          });
          const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          });
          return `${formattedDate} / ${formattedTime}`;
        } catch (error) {
          return '-';
        }
      },
    },
    { key: 'spacer', label: '' },
    {
      key: 'role',
      label: 'Role',
      sortable: true,
      width: 100,
      render: (role: string) => {
        if (!role) return '-';

        const roleLabels: { [key: string]: string } = {
          'admin': 'Admin',
          'packer': 'Packer',
          'receiver': 'Receiver',
          'security': 'Security Guard',
          'user': 'User'
        };

        return roleLabels[role] || role;
      },
    },
    {
      key: 'isactive',
      label: 'Status',
      sortable: true,
      width: 60,
      render: (value: string) => {
        if (value === 'Y') {
          return <SuccessIcon width={20} height={20} />;
        }
        return <ErrorIcon width={20} height={20} />;
      },
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleSort = (_column: string, _direction: 'asc' | 'desc') => {
    // TODO: Implement sorting logic
  };

  const pagination: SimplePaginationInfo = {
    page: currentPage,
    limit: 10, // Show 10 records per page
  };

  return (
    <>
      {/* User Statistics Cards */}
      <div className="d-flex card-userStats gap-4 mb-4">
        <div className="">
          <UserStatsCard
            title="Total Reg. Users"
            totalCount={stats.total.count}
            breakdown={stats.total.breakdown}
          />
        </div>
        <div className="">
          <UserStatsCard
            title="Total Active Users"
            totalCount={stats.active.count}
            icon={<SuccessIcon width={15} height={15} />}
            breakdown={stats.active.breakdown}
          />
        </div>
        <div className="">
          <UserStatsCard
            title="Total Disabled Users"
            totalCount={stats.disabled.count}
            icon={<ErrorIcon width={15} height={15} />}
            breakdown={stats.disabled.breakdown}
          />
        </div>
      </div>

      {/* Users Data Table */}
      <div style={{ height: 'calc(100% - 120px)', backgroundColor: '#e9e6ec'}}>
        <DataTable
          columns={columns}
          data={list}
          loading={loading}
          pagination={pagination}
          onPageChange={handlePageChange}
          onSort={handleSort}
          searchable={false}
        />
      </div>
    </>
  );
};

export default UsersGrid;

